<template>
	<div>
		<div :class="tabsClasses">
			<ul>
				<li v-for="(tab, key) in tabs" :key='key' :class="[{'is-active': tab.isActive}, tab.tabClass]">
					<a @click="selectTab(tab)">						
						{{tab.name}}
					</a>
				</li>
			</ul>
		</div>
		<div :class="tabDetailClass">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabs: []
			}
		},
		props: {
			tabsClass: { type: String, default: '' },
			tabDetailClass: { type: String, default: '' }
		},
		computed: {
			tabsClasses() {
				return 'tabs ' + this.tabsClass;
			},
		},
		methods: {
			selectTab(selectedTab) {
				this.tabs.forEach((tab) => {
					tab.isActive = (tab.name == selectedTab.name);
				});
				selectedTab.$emit('gems-tab-selected', selectedTab);
			}
		},
		created() {
			this.tabs = this.$children;
		}
	}
</script>
<style scoped lang="scss">
	@import '../../assets/sass/main.scss';

	.tabs {
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
		margin-bottom: 0 !important;
	}

		.tabs a {
			height: 5.4rem;
			color: #6CC5CA;
		}

			.tabs a:hover {
				border-bottom-color: $cyan;
				border-bottom-width: 2px;
				color: $cyan;
			}

		.tabs li.is-active a {
			border-bottom-color: $white;
			border-bottom-width: 2px;
			color: $white;
		}
</style>

